import { patchState, signalStore, withHooks, withMethods } from "@ngrx/signals";
import { setAllEntities, setEntity, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { Observable, pipe, switchMap, tap } from "rxjs";
import { ApiQuestsService } from "../../services/api-quests.service";
import { QuestViewModel } from "@playcharge/common/models/backend/quests/backoffice/quest-view-model";
import { QuestCreateModel } from "@playcharge/common/models/backend/quests/backoffice/quest-create-model";
import { QuestEditModel } from "@playcharge/common/models/backend/quests/backoffice/quest-edit-model";

export type QuestsStore = InstanceType<typeof QuestsStore>;

export const QuestsStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<QuestViewModel>(),
    withRequestStatus(),
    withMethods((store, apiQuestsService = inject(ApiQuestsService)) => ({
        loadQuests: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiQuestsService.getQuests().pipe(
                        tap((quests) => {
                            patchState(store, setAllEntities(quests));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        createQuest(model: QuestCreateModel): Observable<QuestViewModel> {
            return apiQuestsService.createQuest(model).pipe(
                tap((quest) => {
                    patchState(store, setEntity(quest));
                }),
            );
        },
        editQuest(model: QuestEditModel): Observable<QuestViewModel> {
            return apiQuestsService.editQuest(model).pipe(
                tap((quest) => {
                    patchState(store, setEntity(quest));
                }),
            );
        },
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadQuests();
        },
    })),
);
